import { TenantUIController } from '../domains/Tenant/infrastructure/controllers/Tenant.ui.controller';
import { UserUIService } from '../domains/User/application/User.ui.service';
import { UserPrincipalUIController } from '../external/UserPrincipal/infrastructure/controllers/UserPrincipal.ui.controller';
import { inversifyContainer } from '../inversifyContainer';

export class UIApplication {
  private static instance: UIApplication;
  public readonly tenantUIController: TenantUIController;
  public readonly userPrincipalUIController: UserPrincipalUIController;
  public readonly userUIController: UserUIService;

  public static getInstance(): UIApplication {
    if (!UIApplication.instance) {
      UIApplication.instance = new UIApplication();
    }
    return UIApplication.instance;
  }

  private constructor() {
    this.tenantUIController = inversifyContainer.get(TenantUIController);
    this.userUIController = inversifyContainer.get(UserUIService);

    this.userPrincipalUIController = inversifyContainer.get(
      UserPrincipalUIController,
    );
  }
}
